<template>
  <div v-if="helper.master.labels">
    <spacer :y="5"/>
    <contents-box
      :title="`${organizationTypeLabel}情報入力`"
      id="confirm">
      <div :class="$style.wrapper">
        <div
          v-for="row in organizationTypes"
          :key="row">
          <div :class="rowGroupClass(row.name)" v-if="hideDisplay(row)">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ row.label }}</p>
              <p v-if="row.required" :class="$style.required">※必須項目</p>
            </div>
            <div
              :class="$style.detail"
              v-if="row.type === 'radio'">
              <ul :class="$style.radio">
                <li
                  v-for="opt in row.options"
                  :key="opt">
                  <input
                    type="radio"
                    :name="row.name"
                    :id="opt.name"
                    :disabled="flag.isConfirm"
                    :value="opt.value"
                    v-model="this[row.name]"
                    @change="changeOrganizationType(row.name)">
                  <label :for="opt.name">{{ opt.label }}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <div v-for="row in orderedContents" :key="row">
          <div :class="rowGroupClass(row.name)" v-if="hideDisplay(row) && row.name !== 'billing_type'">
            <!-- グループ見出し（既存ラベルを昇格できないグループのみ描画される） -->
            <p
              v-if="rowGroupHeading(row.name)"
              :class="$style.group_heading">{{ rowGroupHeading(row.name) }}</p>
            <div :class="$style.label_wrap">
              <p :class="rowLabelClass(row.name)">
                {{ row.schoolAdminField ? getSchoolAdminLabel(row.name) : row.label }}
              </p>
              <p
                v-if="(row.required && row.name !== 'school_type')
                  || (row.required && row.name === 'school_type' && !this.is_company)"
                :class="$style.required">※必須項目</p>
            </div>
            <!-- 契約プラン/パターン種別はブロックA（school_type アンカー）、契約名/契約年月日/契約担当者は
                 ブロックB（textDefaultCount アンカー）で描画する。各アンカー行の兄弟 block を参照。 -->

            <!-- ラジオボタン（コース） -->
            <!-- <div :class="$style.detail" v-if="row.type === 'radio' && row.name === 'course'">
              <ul :class="$style.radio">
                <li v-for="opt in courseOptions[billing_type]" :key="opt">
                  <input
                    type="radio"
                    :name="row.name"
                    :id="opt.name"
                    :disabled="flag.isConfirm"
                    :value="opt.value"
                    v-model="row.value">
                  <label :for="opt.name">{{ opt.label }}</label>
                </li>
              </ul>
            </div> -->

            <!-- ラジオボタン（学校タイプ） -->
            <div
              :class="$style.detail"
              v-if="row.type === 'radio'
                && row.name !== 'billing_type'
                && row.name !== 'course'
                && row.name === 'school_type'">
              <ul :class="$style.radio">
                <li v-for="opt in row.options" :key="opt">
                  <input
                    type="radio"
                    :name="row.name"
                    :id="opt.name"
                    :disabled="flag.isConfirm || this.is_company"
                    :value="opt.value"
                    v-model="school_type">
                  <label
                    :for="opt.name"
                    :class="this.is_company
                      ? 'disabled'
                      : ''">{{ opt.label }}</label>
                </li>
              </ul>
            </div>

            <!-- テキスト -->
            <div :class="$style.detail" v-if="row.type === 'text'">
              <div>
                <input
                  v-if="row.name != 'kana' && row.name != 'kana1' && row.name != 'password'"
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : (row.schoolAdminField ? getSchoolAdminPlaceholder(row.name) : (is_company && row.cplaceholder ? row.cplaceholder : row.placeholder))"
                  type="text" v-model="row.value">
                <input
                  v-if="row.name === 'kana'"
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : (is_company && row.cplaceholder ? row.cplaceholder : row.placeholder)"
                  v-model.trim="$v.siteKana.$model"
                  v-on:input="onKanaInput(row, 'siteKana', $v.siteKana.$model, $v.siteKana.$invalid)"
                  @compositionend="onKanaCompositionEnd('siteKana', row)"
                  @blur="onKanaCompositionEnd('siteKana', row)"
                  type="text">
                <input
                  v-if="row.name === 'kana1'"
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model.trim="$v.kana1.$model"
                  v-on:input="onKanaInput(row, 'kana1', $v.kana1.$model, $v.kana1.$invalid)"
                  @compositionend="onKanaCompositionEnd('kana1', row)"
                  @blur="onKanaCompositionEnd('kana1', row)"
                  type="text">
                <input
                  v-if="row.name === 'password'"
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model.trim="$v.password.$model"
                  v-on:input="onPasswordInput(row)"
                  type="text">
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
              <p v-if="row.name === 'kana'&& $v.siteKana.$dirty && $v.siteKana.custom.$invalid" :class="$style.required">カナ文字のみ入力してください</p>
              <p v-if="row.name === 'kana1'&& $v.kana1.$dirty && $v.kana1.custom.$invalid" :class="$style.required">カナ文字のみ入力してください</p>
              <p v-if="row.name === 'password' && $v.password.$dirty && $v.password.minLength.$invalid" :class="$style.required">パスワードは8文字以上で設定してください</p>
              <p v-if="row.name === 'password' && $v.password.$dirty && $v.password.maxLength.$invalid" :class="$style.required">パスワードは15文字以下で設定してください</p>
              <p v-if="row.name === 'password' && !flag.isConfirm" :class="$style.assistant">半角英数字8桁以上15桁以下</p>
            </div>

            <!-- 数値 -->
            <div :class="$style.detail" v-if="row.type === 'number'">
              <div :class="$style.number">
                <input
                  :class="$style.text_number"
                  :name="row.name"
                  :disabled="flag.isConfirm || contents[0].value === 2"
                  v-model="row.value"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  type="number"
                  :min="row.min">
                <spacer :y="2"/>
                <p :class="$style.label">{{ row.unit }}</p>
                <spacer :y="4"/>
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
            </div>

            <div :class="$style.detail" v-if="row.name === 'emailUser'">
              <div>
                <input
                  :class="$style.text"
                  :disabled="flag.isConfirm"
                  placeholder="メールアドレス"
                  v-model.trim="$v.mailUser.$model"
                  id="mailUser"
                  type="emailUser"
                  name="mailUser"
                  v-on:input="invalidsCheck('mailUser', $v.mailUser.$invalid)">
                <p
                  :class="$style.required"
                  v-if="$v.mailUser.$dirty
                    && $v.mailUser.required.$invalid">メールアドレスを入力してください</p>
                <p
                  :class="$style.required"
                  v-if="$v.mailUser.$dirty
                    && $v.mailUser.email.$invalid">正しいメールアドレスの形式で入力してください</p>
              </div>
            </div>

            <!--住所-->
            <div :class="$style.detail" v-if="row.type === 'address'">
              <Address
                @sendValue="receiveValue"
                :items="items"
                :isConfirm="flag.isConfirm" />
            </div>
          </div>

          <!-- ブロックA: 契約プラン・パターン種別を組織タイプ/学校タイプ直下へ配置（B2 再分割）。
               school_type 行をアンカーにする（is_company 組織では学校タイプ本体は非表示だが
               v-for 反復は常に走るためこの block は常に描画される）。 -->
          <div :class="$style.row" v-if="row.name === 'school_type'">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ contents[0].label }}</p>
              <p v-if="contents[0].required" :class="$style.required">※必須項目</p>
            </div>
            <div :class="$style.detail">
              <ul :class="$style.radio">
                <li v-for="opt in billingPlanOptions" :key="opt">
                  <input
                    type="radio"
                    :name="contents[0].name"
                    :id="opt.name"
                    :disabled="flag.isConfirm"
                    :value="opt.value"
                    v-model="contents[0].value"
                    v-on:change="updateBillingType">
                  <label :for="opt.name">{{ opt.label }}</label>
                </li>
              </ul>
              <div>
                <spacer :y="2" />
                <ul :class="$style.contract">
                  <!-- パターン種別（measuredDatas の radio 行のみ）。v-if+v-for 同居は Vue3 で loop 変数を
                       参照できないため template v-for + li v-if で行フィルタする。 -->
                  <template v-for="row in measuredDatas">
                    <li v-if="row.inputType === 'radio'" :key="row" :class="$style.contract_list">
                      <div v-if="judgeDisplay(row)" :class="$style.label_wrap">
                        <p :class="$style.label">{{ row.label }}</p>
                      </div>
                      <div>
                        <ul v-if="row.cycle && contents[0].value === 1" :class="$style.radio">
                          <li v-for="opt in row.cycle" :key="opt">
                            <input
                              type="radio"
                              :name="row.label"
                              :id="opt.label"
                              :disabled="flag.isConfirm"
                              :value="opt.value"
                              v-model="row.value">
                            <label :for="opt.label">{{ opt.label }}</label>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>

          <!-- ブロックB: 契約名・契約年月日（measuredDatas の非 radio 行）をテキスト基本利用回数の直下へ配置。
               textDefaultCount 行をアンカーにする（hideAccount でサステナブル時は本体（数値入力）が非表示になるが、
               v-for 反復は常に走るためこの block は常に描画される。契約名/契約年月日は両プラン共通なのでこれで正しい）。
               契約プラン・パターン種別はブロックA（組織タイプ直下）へ分離した。 -->
          <div :class="$style.row" v-if="row.name === 'textDefaultCount'">
            <div :class="$style.detail">
              <ul :class="$style.contract_flat">
                <template v-for="row in measuredDatas">
                  <li v-if="row.inputType !== 'radio'" :key="row" :class="$style.contract_list">
                    <div v-if="judgeDisplay(row)" :class="$style.label_wrap">
                      <p :class="$style.label">{{ row.label }}</p>
                      <p v-if="row.required && row.inputType !== 'radio'" :class="$style.required">※必須項目</p>
                    </div>
                    <div v-if="row.name === 'contractDate'"><!-- 契約年月日 -->
                      <ul :class="$style.select_wrap">
                        <li>
                          <select
                            :class="$style.select"
                            name="contractDate"
                            id="year"
                            :disabled="flag.isConfirm"
                            @change="updateContractDate"
                            v-model="row.values.year">
                          <option :value="0"></option>
                          <option
                            v-for="n of 20"
                            :key="n"
                            :value="optionYear(n)">{{ optionYear(n) }}</option>
                          </select>年
                        </li>
                        <li>
                          <select
                            :class="$style.select"
                            name="contractDate"
                            id="month"
                            :disabled="flag.isConfirm"
                            @change="updateContractDate"
                            v-model="row.values.month">
                          <option :value="0"></option>
                          <option
                            v-for="n of 12"
                            :key="n"
                            :value="n">{{ n }}</option>
                          </select>月
                        </li>
                        <li>
                          <select
                            :class="$style.select"
                            name="contractDate"
                            id="day"
                            :disabled="flag.isConfirm"
                            @change="updateContractDate"
                            v-model="row.values.day">
                          <option :value="0"></option>
                          <option
                            v-for="n of 31"
                            :key="n"
                            :value="n">{{ n }}</option>
                          </select>日
                        </li>
                      </ul>
                    </div>
                    <input v-else
                      :class="row.inputType === 'text' ? $style.text : $style.text_number"
                      :type="row.inputType"
                      :disabled="flag.isConfirm"
                      v-model="row.value">
                    <span v-if="row.name === 'textDefaultCount'" :class="[$style.label, $style.text_default_count]"> 回</span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>

        <div :class="$style.row">
          <div :class="$style.label_wrap">
            <p :class="$style.label">副管理者</p>
          </div>
          <p :class="$style.helper_text">※ 副管理者は最大 {{ subAdminLimit }} 名まで登録できます</p>
          <spacer :y="1"/>
          <div :class="$style.detail">
            <div v-for="(group, gi) in subUserGroups" :key="gi" :class="$style.sub_admin_block">
              <contents-box :title="`副管理者 ${gi + 1}`" type="inner">
                <template v-for="item in group.items">
                  <div
                    :key="item.name"
                    :class="subRowClass(group.items, item)"
                    v-if="!item.schoolAdminField || visibleSchoolAdminKeysSub.includes(item.name)">
                    <div :class="$style.label_wrap">
                      <p :class="$style.sub_label">{{ getSubItemLabel(item) }}</p>
                      <p v-if="item.required" :class="$style.required">※必須項目</p>
                    </div>
                    <div :class="$style.detail">
                      <div>
                        <input
                          type="text"
                          :class="$style.text"
                          :disabled="flag.isConfirm"
                          v-model="item.value"
                          :placeholder="flag.isConfirm ? '' : getSubItemPlaceholder(item)"
                          @blur="item.name === 'kana' ? normalizeSubGroupKana(item) : null">
                      </div>
                    </div>
                  </div>
                </template>
                <btn-container v-if="!flag.isConfirm">
                  <basic-btn
                    tag="button"
                    size="sm"
                    type="bdr"
                    addClass="danger"
                    v-on:click="removeSubAdminGroup(gi)">この副管理者を削除</basic-btn>
                </btn-container>
              </contents-box>
              <spacer :y="2"/>
            </div>
            <basic-btn
              v-if="!flag.isConfirm && subUserGroups.length < subAdminLimit"
              tag="button"
              size="sm"
              v-on:click="addSubAdminGroup">副管理者を追加</basic-btn>
          </div>
        </div>

        <!-- 契約担当者（副管理者ブロックの直下）。
             法人名／法人名カナは「管理者と同一」チェックボックスより上・v-if の外に置き、ON/OFF に
             関わらず常時表示する。v-if の内側だと既定 ON（実運用のほぼ全組織）で入力欄が消え、
             法人名が必須（backend の register も corporate_name 無しを 422 で弾く）のため
             新規登録自体が成立しなくなるため。
             保存先は schools.corporate_name / corporate_kana で、ON で contractPersons 行を
             作らなくても法人名は残る。 -->
        <div :class="$style.row">
          <div :class="$style.label_wrap">
            <p :class="$style.label">契約担当者</p>
          </div>
          <div :class="$style.detail">
            <spacer :y="2"/>
            <div :class="$style.label_wrap">
              <p :class="$style.sub_label">{{ corporateNameRow.label }}</p>
              <p v-if="corporateNameRow.required" :class="$style.required">※必須項目</p>
            </div>
            <input
              :class="$style.text"
              type="text"
              :name="corporateNameRow.name"
              :disabled="flag.isConfirm"
              :placeholder="flag.isConfirm ? '' : corporateNameRow.placeholder"
              v-model="corporateNameRow.value">
            <spacer :y="2"/>
            <div :class="$style.label_wrap">
              <p :class="$style.sub_label">{{ corporateKanaRow.label }}</p>
              <p v-if="corporateKanaRow.required" :class="$style.required">※必須項目</p>
            </div>
            <input
              :class="$style.text"
              type="text"
              :name="corporateKanaRow.name"
              :disabled="flag.isConfirm"
              :placeholder="flag.isConfirm ? '' : corporateKanaRow.placeholder"
              v-model.trim="$v.kana.$model"
              v-on:input="onKanaInput(corporateKanaRow, 'kana', $v.kana.$model, $v.kana.$invalid)"
              @compositionend="onKanaCompositionEnd('kana', corporateKanaRow)"
              @blur="onKanaCompositionEnd('kana', corporateKanaRow)">
            <p
              v-if="$v.kana.$dirty && $v.kana.custom.$invalid"
              :class="$style.required">カナ文字のみ入力してください</p>
            <spacer :y="2"/>
            <label :class="$style.same_as_admin">
              <input
                type="checkbox"
                :disabled="flag.isConfirm"
                v-model="contractPerson.sameAsAdmin">
              管理者と同一
            </label>
            <div v-if="!contractPerson.sameAsAdmin">
              <spacer :y="2"/>
              <div :class="$style.label_wrap">
                <p :class="$style.sub_label">氏名</p>
                <p :class="$style.required">※必須項目</p>
              </div>
              <input
                :class="$style.text"
                type="text"
                :disabled="flag.isConfirm"
                :placeholder="flag.isConfirm ? '' : '例：山田 太郎'"
                v-model="contractPerson.name">
              <spacer :y="2"/>
              <div :class="$style.label_wrap">
                <p :class="$style.sub_label">カナ</p>
                <p :class="$style.required">※必須項目</p>
              </div>
              <input
                :class="$style.text"
                type="text"
                :disabled="flag.isConfirm"
                :placeholder="flag.isConfirm ? '' : '例：ヤマダ タロウ'"
                v-model="contractPerson.kana"
                @blur="normalizeContractPersonKana">
              <!-- 契約担当者の部署/職階は組織種類によらず固定 2 列（mixin contractPersonFieldDefs が定義元）。
                   主管理者の表示列制御（visibleSchoolAdminKeys・種別で列数可変）とは別軸なので参照しない。
                   下の必須判定・alert 語彙も同じ defs を走査するため、入力欄の増減と必須チェックの
                   対象が構造的にズレない（欄が無いのに必須で止まる false-block を防ぐ）。 -->
              <template v-for="f in contractPersonFieldDefs()" :key="f.name">
                <spacer :y="2"/>
                <div :class="$style.label_wrap">
                  <p :class="$style.sub_label">{{ f.label }}</p>
                  <p :class="$style.required">※必須項目</p>
                </div>
                <input
                  :class="$style.text"
                  type="text"
                  :disabled="flag.isConfirm"
                  v-model="contractPerson[f.name]">
              </template>
              <spacer :y="2"/>
              <div :class="$style.label_wrap">
                <p :class="$style.sub_label">電話番号</p>
                <p :class="$style.required">※必須項目</p>
              </div>
              <input
                :class="$style.text"
                type="text"
                :disabled="flag.isConfirm"
                v-model="contractPerson.tel">
              <p :class="$style.assistant" v-if="!flag.isConfirm">半角・ハイフンなしで入力してください</p>
              <spacer :y="2"/>
              <div :class="$style.label_wrap">
                <p :class="$style.sub_label">メールアドレス</p>
                <p :class="$style.required">※必須項目</p>
              </div>
              <input
                :class="$style.text"
                type="email"
                :disabled="flag.isConfirm"
                :placeholder="flag.isConfirm ? '' : 'メールアドレス'"
                v-model.trim="contractPerson.email">
              <spacer :y="2"/>
              <div :class="$style.label_wrap">
                <p :class="$style.sub_label">住所</p>
                <p :class="$style.required">※必須項目</p>
              </div>
              <!-- 組織住所（addresses）とは別インスタンス。DOM id の衝突を避けるため idPrefix を渡す
                   （渡さないと id="zip" 等が重複し label クリックが先頭インスタンスへ吸われる）。
                   items は Address 側では読み取り専用の定義配列なので組織住所と同じものを共有する。 -->
              <Address
                @sendValue="receiveContractPersonValue"
                :items="items"
                :isConfirm="flag.isConfirm"
                idPrefix="cp" />
            </div>
          </div>
        </div>

        <div :class="$style.row">
          <div :class="$style.label_wrap">
            <p :class="$style.label">医師心理士への共有メモ</p>
          </div>
          <spacer :y="1" />
          <div :class="$style.detail">
            <textarea
              :class="$style.textarea"
              v-model="features"
              :disabled="flag.isConfirm"
              placeholder="導入校・導入企業の特色を入力してください。入力テキストは医師心理士サイト上で閲覧可能です。"
              rows="5"></textarea>
          </div>
        </div>
        <div :class="$style.row">
          <div :class="$style.label_wrap">
            <p :class="$style.label">メモ（事務局のみ閲覧可）</p>
          </div>
          <spacer :y="1" />
          <div :class="$style.detail">
            <textarea
              :class="$style.textarea"
              v-model="schoolMemo"
              :disabled="flag.isConfirm"
              placeholder="備考"
              rows="5"></textarea>
          </div>
        </div>

      </div>
      <spacer :y="5"/>
      <btn-container>
        <basic-btn
          tag="button"
          v-if="!flag.isConfirm"
          v-on:click="changeFlag">入力内容を確認する</basic-btn>
        <basic-btn
          tag="button"
          v-if="flag.isConfirm"
          v-on:click="changeFlag">編集画面に戻る</basic-btn>
        <spacer :x="2"/>
        <basic-btn
          tag="button"
          v-if="flag.isConfirm"
          v-on:click="regist">入力内容を確定する</basic-btn>
      </btn-container>
    </contents-box>
    <spacer :y="8.5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import {
  email,
  required,
  minLength,
  maxLength,
} from '@vuelidate/validators';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import { Address } from '@/views/components/parts/Form';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';
import saf from '@/mixins/schoolAdminFunctions';
import csm from '@/mixins/corporateSchool';
import { normalizeKana, isValidKana } from '@/lib/normalizeKana';
import moment from 'moment';

// フォーム項目のグループ定義（罫線の括り単位）。住所ブロック（parts/Form/Address.vue）と同じ
// 「1 罫線の中に関連項目をまとめる」表現を他項目へ展開するためのもの。
// - members は描画順で並べる。先頭/中間/最終は「そのとき可視な member」から動的に決めるため、
//   可変表示（企業/インターンで学校タイプ非表示 等）で罫線が消えたり下余白が詰まったりしない。
// - promoted: 見出しに昇格させる既存ラベルを持つ行名。指定があるとその行のラベルが見出しを兼ねる
//   （新語を増やさない）。null のグループは見出し行を別途描画する。
// - indented: 見出しの選択に従属する子行（契約プラン配下の「パターン種別」と同じ 1em の字下げを付ける）。
const FIELD_GROUPS = [
  {
    name: 'orgType',
    heading: '組織タイプ',
    promoted: 'orgType',
    members: ['orgType', 'school_type'],
    indented: ['school_type'],
  },
  // サイト表示名（schools.name / kana）。法人名（schools.corporate_name / corporate_kana）は契約担当者
  // ブロック内で描画するため、どのグループにも属さない（罫線グループの仕組みを使わない）。
  {
    name: 'siteName', heading: 'サイト表示名', promoted: 'name', members: ['name', 'kana'],
  },
  {
    name: 'admin',
    heading: '管理者情報',
    promoted: null,
    members: ['username1', 'kana1', 'emailUser', 'department', 'position', 'role', 'password'],
  },
];

export default {
  name: 'signup',
  mixins: [cf, saf, csm],
  components: {
    BasicBtn,
    BtnContainer,
    ContentsBox,
    Spacer,
    Address,
  },
  data() {
    return {
      flag: {
        isConfirm: false,
        readySubmit: false,
        // 契約担当者住所（Address の 2 インスタンス目）のサブミット可否。組織住所の readySubmit とは別枠で持つ。
        readySubmitContractPerson: false,
        registSubUser: false,
      },
      validationFlags: {
        mailUser: false,
        subUser: false,
        kana: false,
        siteKana: false,
        kana1: false,
        kana2: false,
      },
      invalids: {
        mailUser: true,
        subUser: true,
        kana: false,
        siteKana: false,
        kana1: false,
        kana2: false,
        password: true,
      },
      billing_type: 'default',
      // 組織区分は3カラム（is_company/is_corporate/school_type）で DB 保持する。UI は単一
      // 「組織タイプ」3択（orgType）で操作し、changeOrganizationType で3カラムへ導出する（保持仕様は不変）。
      is_company: 0,
      is_corporate: 0,
      // UI 用の単一セレクタ。0=学校(0,0) / 1=インターン(1,0) / 2=企業(1,1)。
      orgType: 0,
      organizationTypes: [
        {
          type: 'radio',
          name: 'orgType',
          label: '組織タイプ',
          required: true,
          value: 0,
          options: [
            {
              name: 'orgSchool',
              label: '学校',
              value: 0,
            },
            {
              name: 'orgIntern',
              label: 'インターン',
              value: 1,
            },
            {
              name: 'orgCompany',
              label: '企業',
              value: 2,
            },
          ],
        },
      ],
      contents: [
        // contents[0]は課金モデルで固定
        {
          type: 'radio',
          name: 'billing_type',
          label: '契約プラン',
          required: true,
          value: 1,
          datatype: 2,
          options: [
            {
              name: 'default',
              label: 'スポットプラン',
              value: 1,
            },
            {
              name: 'account',
              label: 'サステナブルプラン',
              value: 2,
            },
          ],
        },
        // contents[1]は学校タイプで固定
        {
          type: 'radio',
          name: 'school_type',
          label: '学校タイプ',
          required: true,
          value: 1,
          datatype: 1,
          options: [
            {
              name: 'elementary',
              label: '小学校',
              value: 1,
            },
            {
              name: 'juniorHigh',
              label: '中学校',
              value: 2,
            },
            {
              name: 'high',
              label: '高校',
              value: 3,
            },
            {
              name: 'univ',
              label: '専門・短大・大学',
              value: 4,
            },
            {
              name: 'free',
              label: 'フリースクール',
              value: 5,
            },
            {
              name: 'personal',
              label: '個人向け',
              value: 0,
            },
          ],
        },
        // contents[2]は初期利用可能回数で固定
        {
          type: 'number',
          name: 'count',
          label: 'オンライン・バーチャル利用可能回数',
          required: false,
          placeholder: '例：24',
          unit: 'クレジット',
          min: 0,
          value: '',
          datatype: 6,
          hideAccount: true,
        },
        {
          type: 'number',
          name: 'textDefaultCount',
          label: 'テキスト基本利用回数',
          required: true,
          placeholder: '例：30',
          unit: '回',
          value: '',
          hideAccount: true,
        },
        // { // オンラインの基本回数はまだ実装しない
        //   inputType: 'number',
        //   label: 'オンライン基本回数',
        //   naem: 'onlineDefaultCount',
        //   value: null,
        //   required: true,
        // },
        {
          // 法人名（契約主体の名称）。主ループでは描画せず、契約担当者ブロック内で描画する
          // （orderedContents で除外）。行自体は残す＝送信経路 datatype:1 は不変。
          // ラベルは全組織タイプ共通のため cplaceholder による出し分けは持たない。
          type: 'text',
          name: 'corporate_name',
          label: '法人名',
          required: true,
          placeholder: '例：〇〇学園／〇〇株式会社',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'corporate_kana',
          label: '法人名カナ',
          required: true,
          placeholder: '例：◯◯ガクエン／◯◯カブシキガイシャ',
          value: '',
          datatype: 1,
        },
        {
          // サイト表示名（利用者・学校管理者のヘッダーに看板として出す名称）
          type: 'text',
          name: 'name',
          label: 'サイト表示名',
          required: true,
          placeholder: '例：〇〇高校',
          cplaceholder: '例：〇〇株式会社',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'kana',
          // 「サイト表示名」グループの子行。見出し（サイト表示名）と重ねて読ませるためラベルは短縮する
          label: 'カナ',
          required: true,
          placeholder: '例：◯◯コウコウ',
          cplaceholder: '例：◯◯カブシキガイシャ',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'tel',
          label: '電話番号',
          required: true,
          assistant: '半角・ハイフンなしで入力してください',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'fax',
          label: 'fax',
          value: '',
          datatype: 1,
        },
        {
          type: 'address',
          name: 'address',
          label: '住所',
          required: true,
          value: '',
          datatype: 3,
        },
        {
          // 以下は「管理者情報」グループの子行。見出し側が「管理者」を担うためラベルから接頭辞を外し、
          // 同一画面の「契約担当者」ブロック（氏名/カナ/部署/職階）と表記を揃える
          type: 'text',
          name: 'username1',
          label: '氏名',
          required: true,
          placeholder: '例：山田 太郎',
          value: '',
          datatype: 4,
        },
        {
          type: 'text',
          name: 'kana1',
          label: 'カナ',
          required: true,
          placeholder: '例：ヤマダ タロウ',
          value: '',
          datatype: 4,
        },
        {
          type: 'email',
          name: 'emailUser',
          label: 'メールアドレス',
          datatype: 999,
          required: true,
        },
        // 所属/職階/役割（schoolAdmins）。サイト種別で表示列のみ表示（hideDisplay・種別により列数可変）・ラベルは labels.json schoolAdminFields。
        // 物理3列を常に保持し datatype:4 で mainUserData へ。非表示列は regist() で null 送信。
        {
          type: 'text', name: 'department', schoolAdminField: true, required: true, value: '', datatype: 4,
        },
        {
          type: 'text', name: 'position', schoolAdminField: true, required: true, value: '', datatype: 4,
        },
        {
          type: 'text', name: 'role', schoolAdminField: true, required: true, value: '', datatype: 4,
        },
        {
          type: 'text',
          name: 'password',
          label: 'パスワード',
          required: true,
          placeholder: 'パスワード',
          value: '',
          datatype: 4,
        },
      ],
      /**
       * 副管理者グループ（最大 4 名）。新形式 subUserGroups は backend (School/v1.js) が配列で受領する。
       * 各グループは独立した入力フィールド配列を持つ。
       */
      subUserGroups: [],
      items: [
        {
          name: 'zip',
          type: 'text',
          label: '郵便番号',
          value: null,
          required: true,
          placeholder: '1020074',
          comment: '半角・ハイフンなしで入力してください',
        },
        {
          name: 'pref',
          type: 'select',
          label: '都道府県',
          value: null,
          options: [],
          required: true,
          comment: '',
        },
        {
          name: 'city',
          type: 'text',
          label: '市区町村',
          value: null,
          required: true,
          placeholder: '千代田区九段南',
        },
        {
          name: 'address',
          type: 'text',
          label: '番地',
          value: null,
          required: true,
          placeholder: '1-2-3',
        },
        {
          name: 'building',
          type: 'text',
          label: '建物名・部屋番号（任意）',
          value: null,
          required: false,
          placeholder: '〇〇ビル 4F',
        },
      ],
      features: null,
      schoolMemo: null,
      address: {},
      schoolID: null,
      // 契約担当者（氏名/カナ/部署/職階/メール/電話）。「管理者と同一」は既定 ON で、ON の間は
      // 入力欄を出さず contractPersonData 自体を送らない（backend 側も ON では行を作らない）。
      contractPerson: {
        sameAsAdmin: true,
        name: '',
        kana: '',
        department: '',
        position: '',
        email: '',
        tel: '',
      },
      // 契約担当者の住所。組織住所（addresses）とは別に contractPersons の列へ直接保持する。
      contractPersonAddress: {},
      measuredDatas: [
        {
          inputType: 'text',
          label: '契約名',
          name: 'contractName',
          value: null,
          required: false,
        },
        {
          inputType: 'number',
          label: '契約年月日',
          name: 'contractDate',
          values: {
            year: null,
            month: null,
            day: null,
          },
          required: true,
        },
        {
          cycle: [
            {
              label: '月次パターン',
              value: 1,
              checked: true,
            },
            {
              label: '年次パターン',
              value: 2,
              checked: false,
            },
          ],
          inputType: 'radio',
          label: 'パターン種別',
          naem: 'cycle',
          value: 1,
          required: true,
        },
      ],
      // 初期値
      school_type: 1,
    };
  },
  setup() {
    const mailUser = ref('');
    // kana = 法人名カナ（schools.corporate_kana） / siteKana = サイト表示名カナ（schools.kana）
    const kana = ref('');
    const siteKana = ref('');
    const kana1 = ref('');
    const password = ref('');

    // カタカナ・半角スペース・全角スペースのみ許す
    const kanaTextRule = (value) => /^[ァ-ヶー\s　]+$/u.test(value);

    const rules = {
      // メールはemail形式
      mailUser: { required, email },
      kana: {
        required,
        custom: kanaTextRule,
      },
      siteKana: {
        required,
        custom: kanaTextRule,
      },
      kana1: {
        required,
        custom: kanaTextRule,
      },
      // 学校管理者パスワードは必須・8文字以上15文字以下
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(15),
      },
    };

    const $v = useVuelidate(rules, {
      mailUser, kana, siteKana, kana1, password,
    });

    return {
      mailUser,
      kana,
      siteKana,
      kana1,
      password,
      $v,
    };
  },
  created() {
    if (this.helper.master.prefs) {
      this.items[1].options = this.helper.master.prefs;
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'helper/putMaster') {
          this.items[1].options = mutation.payload.prefs;
        }
      });
    }
  },
  computed: {
    ...mapState(['user', 'helper']),
    /** 区分セレクタ UI（登録画面タイトル）の3区分ラベル。
     *  企業=(1,1)/インターン=(1,0)/学校=(0,0)。
     *  labels.organizationTypes は業務表示(Signup・お知らせ等)と共用で要件2(id=18=企業表記継続)の
     *  ため触れない。ここで局所的に「企業/インターン」を出し分ける。 */
    organizationTypeLabel() {
      if (this.is_company && this.is_corporate) return '企業';
      if (this.is_company) return 'インターン';
      return '学校';
    },
    /** 契約プランの選択肢。企業はサステナブルプラン（全生徒を対象にしたアカウント課金）を契約できないので、
     *  スポットプランだけを出す。 */
    billingPlanOptions() {
      if (this.is_company && this.is_corporate) return this.contents[0].options.filter((opt) => opt.value === 1);
      return this.contents[0].options;
    },
    subAdminLimit() {
      return 4;
    },
    /** サイト種別に応じて表示する schoolAdmins 項目（mixin schoolAdminFieldDefs 由来・種別により列数可変） */
    schoolAdminFields() {
      return this.schoolAdminFieldDefs(this.is_company, this.school_type);
    },
    /** 表示中の schoolAdmins 列名（必須判定・表示制御に使用） */
    visibleSchoolAdminKeys() {
      return this.schoolAdminFields.map((field) => field.name);
    },
    /** 副管理者(account_type=12)用の表示列定義。school 種別（小中高/フリースクール/個人）では所属を出さず、
     *  company/university では従来どおり所属を表示する（主管理者用の schoolAdminFields とは別 computed）。 */
    schoolAdminFieldsSub() {
      return this.schoolAdminFieldDefs(this.is_company, this.school_type, 12);
    },
    /** 副管理者の表示中 schoolAdmins 列名（副グループの表示判定・必須判定に使用） */
    visibleSchoolAdminKeysSub() {
      return this.schoolAdminFieldsSub.map((field) => field.name);
    },
    /** 描画順だけを「… 電話番号 → 住所 → サイト表示名 → サイト表示名カナ …」に
     *  組み替えた contents のシャローコピー（各行のオブジェクト参照はそのままなので v-model の束縛先は不変）。
     *  電話番号は住所の直上へ回して連絡先を住所と隣接させ、サイト表示名の組は住所の直後へ回す。
     *  基準は組織メールアドレス撤去まで email 行（電話番号の挿入先）だった。必須項目である住所へ寄せたので、
     *  任意項目が消えて並べ替えごと放棄される（元の contents 順に戻る）ことはない。
     *  法人名（corporate_name / corporate_kana）は契約担当者ブロック内で描画するため主ループの対象から除外する。
     *  data() の contents 自体は contents[0]（契約プラン）/contents[1]（学校タイプ）の index 参照と
     *  送信処理の datatype 振り分けが依存しているため並び替え・行削除をせず、描画側でのみ組み替える。 */
    orderedContents() {
      const afterAddress = ['name', 'kana'];
      const beforeAddress = ['tel'];
      const excludeNames = ['corporate_name', 'corporate_kana'];
      const visible = this.contents.filter((row) => !excludeNames.includes(row.name));
      // アンカー行（住所）が無い構成（将来の項目削除等）では並べ替えを諦めて元の順序をそのまま使う
      if (!visible.some((row) => row.name === 'address')) return visible;
      const moveNames = [...afterAddress, ...beforeAddress];
      const rest = visible.filter((row) => !moveNames.includes(row.name));
      const pick = (names) => names
        .map((name) => visible.find((row) => row.name === name))
        .filter((row) => row);
      const addressAt = rest.findIndex((row) => row.name === 'address');
      return [
        ...rest.slice(0, addressAt),
        ...pick(beforeAddress),
        rest[addressAt],
        ...pick(afterAddress),
        ...rest.slice(addressAt + 1),
      ];
    },
    /** 契約担当者ブロック内で描画する法人名行（contents の実体を参照＝v-model の束縛先は contents 側） */
    corporateNameRow() {
      return this.contents.find((row) => row.name === 'corporate_name');
    },
    /** 同・法人名カナ行 */
    corporateKanaRow() {
      return this.contents.find((row) => row.name === 'corporate_kana');
    },
    /** グループごとの「いま可視な member 行名」（描画順）。罫線の先頭/最終判定に使う。
     *  可視判定は行の描画条件（hideDisplay + billing_type 除外）をそのまま流用し、
     *  表示ゲートと罫線ゲートの軸をずらさない。 */
    groupVisibleMembers() {
      const map = {};
      FIELD_GROUPS.forEach((group) => {
        map[group.name] = group.members.filter((name) => {
          // 組織タイプ行は contents ではなく organizationTypes 側（常時表示）
          if (name === 'orgType') return true;
          const row = this.contents.find((r) => r.name === name);
          return !!row && this.hideDisplay(row) && row.name !== 'billing_type';
        });
      });
      return map;
    },
  },
  methods: {
    judgeDisplay(args) {
      let result = true;
      if (args.cycle) {
        if (this.contents[0].value === 2) result = false;
      }
      return result;
    },
    optionYear(n) {
      const year = Number(this.formatTimestamp(new Date(), 'YYYY')) + 2 - n;
      return year;
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    hideDisplay(row) {
      let showFlag = true;
      if (this.billing_type === 'account') {
        if (row.hideAccount) showFlag = false;
      }
      // 2023/9/8FBでFAXは非表示にしてほしいとのお願い
      if (row.label === 'fax') showFlag = false;
      // 所属/職階/役割 はサイト種別で表示列のみ（非表示列は描画しない・種別により列数可変）
      if (row.schoolAdminField && !this.visibleSchoolAdminKeys.includes(row.name)) showFlag = false;
      // 学校タイプは「学校」区分のみ選択させる。インターン/企業(is_company=1)は school_type=6 固定・非表示。
      if (row.name === 'school_type' && this.is_company) showFlag = false;
      return showFlag;
    },
    /** 行が属するグループ定義（無所属なら undefined） */
    rowGroupOf(rowName) {
      return FIELD_GROUPS.find((group) => group.members.includes(rowName));
    },
    /** 行に当てる罫線・余白クラス。グループ内の可視位置（先頭/中間/最終/単独）で切り替える。
     *  可視 member が 1 つだけに縮退したときは従来の単独行（.row）に戻す。
     *  indented 指定の行にはインデント用クラスを併せて返す。 */
    rowGroupClass(rowName) {
      const group = this.rowGroupOf(rowName);
      if (!group) return this.$style.row;
      const visible = this.groupVisibleMembers[group.name];
      const index = visible.indexOf(rowName);
      let base = this.$style.row_grouped;
      if (index < 0 || visible.length === 1) base = this.$style.row;
      else if (index === 0) base = this.$style.row_group_head;
      else if (index === visible.length - 1) base = this.$style.row_group_last;
      if ((group.indented || []).includes(rowName)) return [base, this.$style.row_indent];
      return base;
    },
    /** グループ見出しの文字列（可視先頭行のみ返す）。promoted 指定のグループは
     *  その行の既存ラベルが見出しを兼ねるため見出し行を出さない。 */
    rowGroupHeading(rowName) {
      const group = this.rowGroupOf(rowName);
      if (!group || group.promoted) return null;
      return this.groupVisibleMembers[group.name][0] === rowName ? group.heading : null;
    },
    /** 行ラベルのクラス。グループの子行は住所ブロックに合わせて 1 段小さく出す */
    rowLabelClass(rowName) {
      const group = this.rowGroupOf(rowName);
      if (!group || group.promoted === rowName) return this.$style.label;
      return this.$style.sub_label;
    },
    /** 副管理者 inner box 内の行クラス。box タイトル（副管理者 N）が見出しを兼ねるため罫線は出さず、
     *  可視最終行だけ下余白を付ける（主管理者側のグループ表現と揃える）。 */
    subRowClass(items, item) {
      const visible = items
        .filter((it) => !it.schoolAdminField || this.visibleSchoolAdminKeysSub.includes(it.name));
      const last = visible[visible.length - 1];
      return last && last.name === item.name ? this.$style.row_group_last : this.$style.row_grouped;
    },
    /** labels.json schoolAdminFields からラベルを引く（表示中の列のみヒット） */
    getSchoolAdminLabel(key) {
      const field = this.schoolAdminFields.find((f) => f.name === key);
      return field ? field.label : '';
    },
    /** labels.json schoolAdminFields からプレースホルダを引く */
    getSchoolAdminPlaceholder(key) {
      const field = this.schoolAdminFields.find((f) => f.name === key);
      return field ? field.placeholder : '';
    },
    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },
    /** カナ入力時にrow.valueへ同期しつつバリデーションチェック */
    onKanaInput(row, name, model, invalid) {
      row.value = model;
      this.invalidsCheck(name, invalid);
    },
    /** パスワード入力時に row.value へ同期しつつ8-15文字バリデーションをチェック。
     *  vuelidate の $v.password.<rule> を method 内から直接参照すると undefined になるケースがあるため、
     *  ここで文字数判定を直接行い invalids に反映する */
    onPasswordInput(row) {
      const value = this.password ?? '';
      row.value = value;
      const len = value.length;
      this.invalidsCheck('password', len < 8 || len > 15);
    },
    /** kana / kana1 / kana2: IME 確定後・blur 時に normalize（入力アシスト）
     *  required + custom 相当を直接判定（空入力 or 不正値で invalid）。
     *  vuelidate の $v 経由参照を避けて HMR / Composition API の参照タイミング差異を回避する */
    onKanaCompositionEnd(refName, row) {
      const normalized = normalizeKana(this[refName]);
      this[refName] = normalized;
      row.value = normalized;
      this.invalidsCheck(refName, !normalized || !isValidKana(normalized));
    },
    /** 子から値を受け取る */
    receiveValue(values) {
      this.flag.readySubmit = values.readySubmit;
      this.address = values.address;
    },
    /** 契約担当者住所（Address の 2 インスタンス目）から値を受け取る。
     *  組織住所とは別のフラグ・別の格納先に載せる（送信先も addresses ではなく contractPersons）。 */
    receiveContractPersonValue(values) {
      this.flag.readySubmitContractPerson = values.readySubmit;
      this.contractPersonAddress = values.address;
    },
    updateBillingType(e) {
      this.billing_type = e.target.id;
      this.contents[1].value = 1;
    },
    /** 副管理者グループ初期テンプレートを生成 */
    _newSubAdminGroup() {
      return {
        // ラベルは inner box のタイトル（副管理者 N）が見出しを担うため接頭辞を付けない
        // （主管理者側「管理者情報」グループの子ラベルと表記を揃える）
        items: [
          {
            name: 'username', label: '氏名', value: '', required: true,
          },
          {
            name: 'kana', label: 'カナ', value: '', required: true,
          },
          {
            name: 'email', label: 'メールアドレス', value: '', required: true,
          },
          // 所属/職階/役割（schoolAdmins）。物理3列を常に保持し、サイト種別で表示列のみ描画（副は visibleSchoolAdminKeysSub・種別により列数可変）。
          // 所属(department)は company/university の副管理者でも必須（required:true）。school 種別では visibleSchoolAdminKeysSub に
          // 含まれず行自体が非描画になるため required:true でも保存ブロックは発生しない。
          {
            name: 'department', value: '', required: true, schoolAdminField: true,
          },
          {
            name: 'position', value: '', required: true, schoolAdminField: true,
          },
          {
            name: 'role', value: '', required: true, schoolAdminField: true,
          },
        ],
      };
    },
    addSubAdminGroup() {
      if (this.subUserGroups.length >= this.subAdminLimit) return;
      this.subUserGroups.push(this._newSubAdminGroup());
    },
    removeSubAdminGroup(index) {
      this.subUserGroups.splice(index, 1);
    },
    getSubItemLabel(item) {
      if (item.schoolAdminField) return this.getSchoolAdminLabel(item.name);
      return item.label;
    },
    getSubItemPlaceholder(item) {
      if (item.schoolAdminField) return this.getSchoolAdminPlaceholder(item.name);
      if (this.is_company && item.cplaceholder) return item.cplaceholder;
      return item.placeholder || '';
    },
    /** 副管理者 kana の正規化 */
    normalizeSubGroupKana(item) {
      const normalized = normalizeKana(item.value);
      item.value = normalized;
    },
    /** 契約担当者 kana の正規化（入力アシスト。blur 時にひらがな→全角カタカナ等へ変換） */
    normalizeContractPersonKana() {
      this.contractPerson.kana = normalizeKana(this.contractPerson.kana);
    },
    /** 必須項目の入力をチェック */
    changeFlag() {
      let filledRequired = true;
      this.contents.forEach((row) => {
        if (row.required) {
          if (!this.hideDisplay(row)) {
            // 画面に出ていない行は必須対象外。必須判定の発火条件を入力 UI の表示ゲート
            // （hideDisplay）と同一にする＝軸一致。サステナブルプランで非表示になる
            // テキスト基本利用回数や、サイト種別で非表示になる所属/職階/役割 がここで除外される。
          } else if (row.name === 'address' || row.name === 'emailUser') {
            // 住所は Address コンポーネントの readySubmit、管理者メールは invalids.mailUser で個別に見る。
            // row.value は使われないためこのループの対象外（この 2 行で filledRequired を true に
            // 再代入すると、それ以前の行の未入力が握り潰される）。
          } else if (row.value === null || row.value === '') {
            filledRequired = false;
          }
        }
        // アカウント課金モデルの場合、初期利用可能回数は未入力にする
        if (row.name === 'billing_type' && row.value === 2) this.contents[2].value = '';
      });

      // 新設・移設した項目は名指しの alert を先に出す（汎用の「必須項目が未入力です」だけだと
      // どの欄を直せばよいか分からないため）。文言は画面の表示ラベルと同語にする。
      // サイト表示名カナ（kana）の row.label は見出し（サイト表示名）と重ねて読む前提の「カナ」なので、
      // 単独で出す alert では欄を特定できる語に置き換える。
      const namedRequiredRows = [
        { name: 'name', label: 'サイト表示名' },
        { name: 'kana', label: 'サイト表示名カナ' },
        { name: 'corporate_name', label: '法人名' },
        { name: 'corporate_kana', label: '法人名カナ' },
      ];
      for (let i = 0; i < namedRequiredRows.length; i += 1) {
        const row = this.contents.find((r) => r.name === namedRequiredRows[i].name);
        if (row && row.required && (row.value === null || row.value === '')) {
          alert(`${namedRequiredRows[i].label}を入力してください`);
          return;
        }
      }

      if (this.contents[0].value === 1) { // 従量課金の時は契約内容の入力を必須化
        this.measuredDatas.forEach((elem) => {
          if (elem.required) {
            if (elem.name === 'contractDate') {
              Object.keys(elem.values).forEach((data) => {
                if (!elem.values[data]) filledRequired = false;
              });
            } else if (!elem.value) filledRequired = false;
          }
        });
      }

      if (!filledRequired) {
        alert('必須項目が未入力です');
        return;
      }
      if (this.invalids.mailUser) {
        alert('管理者のメールアドレスは必須項目です。正しく入力してください。');
        return;
      }
      if (!this.flag.readySubmit) {
        alert('住所の項目に不備があります。');
        return;
      }
      // 副管理者グループの必須・形式チェック
      for (let i = 0; i < this.subUserGroups.length; i += 1) {
        const grp = this.subUserGroups[i];
        const byName = {};
        grp.items.forEach((it) => { byName[it.name] = it.value; });
        if (!byName.username) { alert(`副管理者 ${i + 1} の氏名を入力してください`); return; }
        if (!byName.kana) { alert(`副管理者 ${i + 1} のカナを入力してください`); return; }
        if (byName.kana && !isValidKana(byName.kana)) {
          alert(`副管理者 ${i + 1} のカナはカナ文字のみで入力してください`);
          return;
        }
        if (!byName.email) { alert(`副管理者 ${i + 1} のメールアドレスを入力してください`); return; }
        // 主管理者は vuelidate (mailUser.email) で形式チェック済み。副管理者は動的配列のため
        // 純粋関数（commonFunctions の isValidEmail）で判定する
        // ([[feedback_vuelidate_avoid_array_validation]])。
        if (!this.isValidEmail(byName.email)) {
          alert(`副管理者 ${i + 1} のメールアドレスの形式が正しくありません`); return;
        }
        // 所属/職階/役割 は副の表示中の列のみ必須（純粋関数で判定）。visibleSchoolAdminKeysSub は school 種別では
        // 所属を含まないため、company/university のみ所属が必須対象になる（school 種別は職階/役割のみ）。
        const missingKey = this.visibleSchoolAdminKeysSub
          .find((key) => !byName[key]);
        if (missingKey) { alert(`副管理者 ${i + 1} の${this.getSchoolAdminLabel(missingKey)}を入力してください`); return; }
      }
      // 契約担当者（「管理者と同一」OFF 時のみ）。氏名/カナ必須・カナ形式検証は主管理者と同型（純粋関数判定）。
      // 部署/職階は入力欄と同じ contractPersonFieldDefs を走査して必須判定する（表示と判定の軸一致）。
      // ON のときは入力欄が非表示なので一切チェックしない。
      if (!this.contractPerson.sameAsAdmin) {
        if (!this.contractPerson.name) {
          alert('契約担当者の氏名を入力してください');
          return;
        }
        const cpKana = normalizeKana(this.contractPerson.kana);
        this.contractPerson.kana = cpKana;
        if (!cpKana) {
          alert('契約担当者のカナを入力してください');
          return;
        }
        if (!isValidKana(cpKana)) {
          alert('契約担当者のカナはカナ文字のみで入力してください。');
          return;
        }
        // alert の語は defs の label をそのまま使う＝画面の入力欄ラベルと必ず同語になる
        // （master ラベル(所属等)だと画面に出ていない語でエラーになり操作者が対応先を見失う）
        const cpMissingField = this.contractPersonFieldDefs()
          .find((f) => !this.contractPerson[f.name]);
        if (cpMissingField) {
          alert(`契約担当者の${cpMissingField.label}を入力してください`);
          return;
        }
        // 未入力の指摘順は入力欄の表示順（電話番号 → メールアドレス）に揃える
        // （上から埋める操作者に対して、最初に止まる欄が画面の最上位の空欄になるようにする）
        if (!this.contractPerson.tel) {
          alert('契約担当者の電話番号を入力してください');
          return;
        }
        if (!this.contractPerson.email) {
          alert('契約担当者のメールアドレスを入力してください');
          return;
        }
        // 主管理者は vuelidate (mailUser.email) で形式チェックする。契約担当者は v-if 内でマウント・
        // アンマウントされる欄なので、純粋関数（commonFunctions の isValidEmail）で判定する
        // ([[feedback_vuelidate_avoid_array_validation]] と同じ理由)。
        if (!this.isValidEmail(this.contractPerson.email)) {
          alert('契約担当者のメールアドレスの形式が正しくありません');
          return;
        }
        // 住所は Address コンポーネント側の検証結果（郵便番号/都道府県/市区町村/番地）で判定する
        if (!this.flag.readySubmitContractPerson) {
          alert('契約担当者の住所の項目に不備があります。');
          return;
        }
      }
      if (this.invalids.siteKana) {
        alert('サイト表示名カナはカナ文字のみで入力してください。');
        return;
      }
      if (this.invalids.kana) {
        alert('法人名カナはカナ文字のみで入力してください。');
        return;
      }
      if (this.invalids.kana1) {
        alert('管理者のカナはカナ文字のみで入力してください。');
        return;
      }
      // 学校管理者パスワードは8文字以上15文字以下
      if (this.invalids.password) {
        alert('管理者パスワードは8文字以上15文字以下で設定してください。');
        return;
      }

      this.flag.isConfirm = !this.flag.isConfirm;
      if (this.flag.isConfirm) {
        const elem = document.getElementById('confirm');
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      }
    },

    /** 登録 */
    regist() {
      this.showLoading();
      const data = {
        mainUserData: {},
        billingTypeData: {},
        countHistoriesData: {},
        countHistoriesTextData: {},
      };
      this.contents.forEach((row) => {
        if (row.datatype === 1) {
          data[row.name] = row.value;
        } else if (row.datatype === 2) {
          data.billingTypeData[row.name] = row.value;
        } else if (row.datatype === 4) {
          data.mainUserData[row.name] = row.value;
        } else if (row.datatype === 6) {
          data.countHistoriesData[row.name] = row.value;
        }
      });
      // 組織のメールアドレス（schools.email）は入力欄ごと撤去したため送らない（列とデータは残置）。
      data.mainUserData.email1 = this.mailUser;
      data.is_company = this.is_company;
      // 数値固定で送信（ConvertEmptyStringsToNull で空文字→null 化されると notNullable 違反になるため）
      data.is_corporate = this.is_corporate;
      data.school_type = this.school_type;

      // 主管理者の非表示 schoolAdmin 列は null で送る（種別で表示列のみ・残った旧値を送らない）
      this.clearHiddenSchoolAdminFields(data.mainUserData, this.is_company, this.school_type);

      // 「管理者と同一か」は schools 本体のフラグで保持する（数値固定で送信＝ConvertEmptyStringsToNull の
      // null 化を回避）。ON=1（既定・契約担当者＝主管理者）／OFF=0（個別設定）。
      data.contract_same_as_admin = this.contractPerson.sameAsAdmin ? 1 : 0;

      // 契約担当者の実値は「管理者と同一」OFF のときだけ送る（個別設定の実値専用）。ON のときは
      // 行を作らず、表示側で主管理者情報を代替表示する（backend 側も ON が明示されていれば
      // contractPersonData が来ても行を作らない）。
      if (!this.contractPerson.sameAsAdmin) {
        // 住所は addresses ではなく contractPersons の同名列へ直接載せる（Address が emit する
        // キーと列名を揃えてあるので変換不要）。
        const cpAddress = this.contractPersonAddress || {};
        data.contractPersonData = {
          name: this.contractPerson.name || null,
          kana: this.contractPerson.kana || null,
          department: this.contractPerson.department || null,
          position: this.contractPerson.position || null,
          email: this.contractPerson.email || null,
          tel: this.contractPerson.tel || null,
          zip: cpAddress.zip || null,
          pref: cpAddress.pref || null,
          city: cpAddress.city || null,
          address: cpAddress.address || null,
          building: cpAddress.building || null,
        };
      }

      // courseは入力されないので5の0回を入力してあげる
      data.billingTypeData.course = 5;

      // 副管理者は新形式 subUserGroups 配列で送信（backend が users + schoolAdmins を作成）
      if (this.subUserGroups.length) {
        data.subUserGroups = this.subUserGroups.map((grp) => {
          const obj = {};
          grp.items.forEach((it) => { obj[it.name] = it.value; });
          // 副管理者(12)の非表示列は null で送る（school 種別では所属も除外される）
          this.clearHiddenSchoolAdminFields(obj, this.is_company, this.school_type, 12);
          return obj;
        });
      }
      this.axios({
        method: 'POST',
        url: '/v1/school/set/register',
        data,
      })
        .then((response) => {
          // 同名校が既に存在する場合（backend は exists:true + 既存 schoolID を返す / #3233 C-a）は、
          // 後続の address/billingtype/contract/memo 登録を一切呼ばずに通知して終了する。
          // 存在しない/誤った school_id で後続 API を撃つと 422 を量産し、既存校データを汚す危険があるため（#3233 C-b）。
          if (response.data.exists || !response.data.schoolID) {
            this.hideLoading();
            // 同名判定は backend で schools.name（サイト表示名）に対して行っている
            alert('同名の組織が既に登録されています。サイト表示名をご確認ください。');
            return;
          }
          this.schoolID = response.data.schoolID;
          this.registAddress();
          this.registBillingType(data.billingTypeData);
          this.registContract(data.billingTypeData);
          if (data.countHistoriesData.count) {
            this.registCountHistories(data.countHistoriesData);
          }
          if (this.billing_type === 'default') {
            this.setTextCredit();
          }
          if (this.schoolMemo || this.features) {
            this.registSchoolMemo();
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          // バックエンドのバリデーションエラー（フリガナ等）メッセージがあれば表示
          const serverMessage = error.response && error.response.data && error.response.data.message;
          alert(serverMessage || '組織の登録に失敗しました。');
          this.hideLoading();
        });
    },

    registAddress() {
      const data = this.address;
      data.model_type = 2;
      data.foreign_id = this.schoolID;
      this.axios({
        method: 'POST',
        url: '/v1/address/set/register',
        data,
      })
        .then(() => {
          alert('登録が完了しました。');
          this.hideLoading();
          this.$router.push('/operator/?tab=schools');
        })
        .catch((error) => {
          console.log(error);
          this.hideLoading();
          alert('組織の登録は成功しましたが、組織の住所の登録に失敗しました。');
        });
    },

    registBillingType(billingTypedata) {
      const data = billingTypedata;
      data.school_id = this.schoolID;
      this.axios({
        method: 'POST',
        url: '/v1/school/billingtype/set/register',
        data,
      })
        .then(() => {
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.hideLoading();
          alert('契約プランの登録に失敗しました。');
        });
    },

    registCountHistories(countHistoriesData) {
      const data = countHistoriesData;
      data.billing_type = 1; // アカウント課金モデルの場合はこのメソッドは叩かれない
      data.foreign_id = this.schoolID;
      data.is_add = 1; // 事務局加算扱い
      this.axios({
        method: 'POST',
        url: '/v1/count/history/set/register',
        data,
      })
        .then(() => {
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.hideLoading();
          alert('初期利用可能回数の登録に失敗しました。\nお手数ですが、組織情報更新ページから手動で回数を追加してください。');
        });
    },

    registContract(billingTypeData) {
      // 2024-4-1等をmomentに渡すとInvalid dateになってしまう
      const y = this.measuredDatas[1].values.year;
      const m = String(this.measuredDatas[1].values.month).length === 1
        ? `0${this.measuredDatas[1].values.month}`
        : this.measuredDatas[1].values.month;
      const d = String(this.measuredDatas[1].values.day).length === 1
        ? `0${this.measuredDatas[1].values.day}`
        : this.measuredDatas[1].values.day;
      const contractDate = `${y}-${m}-${d}`;
      let expiry;
      if (this.measuredDatas[2].value === 1) {
        expiry = moment(contractDate).add(30, 'd').format('YYYY-MM-DD');
      } else {
        expiry = moment(contractDate).add(1, 'years').format('YYYY-MM-DD');
      }
      const data = {
        school_id: this.schoolID,
        name: this.measuredDatas[0].value,
        contract_date: contractDate,
        expiry,
        cycle: this.measuredDatas[2].value,
      };

      if (billingTypeData.billing_type === 1) { // 従量課金モデルの場合はテキスト、オンラインの基本回数が存在する
        data.base_text = this.contents[3].value;
        // data.base_online = this.contents[4].value;
      } else {
        data.base_text = 0;
        // data.base_online = 0;
      }

      this.axios({
        method: 'POST',
        url: '/v1/contract/set/register',
        data,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.hideLoading();
          alert('契約情報の登録に失敗しました。');
        });
    },

    // 学校メモの記述があったら登録
    registSchoolMemo() {
      const data = {
        school_id: this.schoolID,
        memo: this.schoolMemo,
        features: this.features,
      };

      this.axios({
        method: 'POST',
        url: '/v1/schoolMemo/set/register',
        data,
      })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          alert('メモの登録に失敗しました。');
        });
    },

    setTextCredit() {
      const data = {
        school_id: this.schoolID,
        count: this.contents[3].value,
        is_add: 1, // 1:特別加算、0:通常（使用）
      };

      this.axios({
        method: 'POST',
        url: '/v1/count/historyText/set/register',
        data,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    changeOrganizationType(name) {
      // 単一「組織タイプ」ラジオ（orgType: 0=学校/1=インターン/2=企業）から
      // is_company / is_corporate / school_type を導出する（DB 保持は3カラムのまま）。
      // フラグ導出は corporateSchool mixin に集約（登録/更新/一覧で単一ソース）。
      if (name !== 'orgType') return;
      const flags = this.orgTypeFlags(this.orgType);
      this.is_company = flags.is_company;
      this.is_corporate = flags.is_corporate;
      // 非学校(インターン/企業)は school_type=6 固定・非表示。学校は既定1（以後ユーザが選択）。
      this.school_type = this.is_company ? 6 : 1;
      // 企業はスポットプランだけ（billingPlanOptions）。先にサステナブルプランを選んでから企業へ切り替えたときに、
      // 見えない選択が残って送信されないよう、スポットプランへ戻す。
      if (this.is_company && this.is_corporate && this.contents[0].value !== 1) {
        this.contents[0].value = 1;
        this.billing_type = 'default';
      }
    },
  },
};
</script>

<style lang="scss" module>
.row {
  padding: 24px 0;
  border-top: 1px solid var(--gray-main);
}
// グループ化された行（罫線 1 本の中に関連項目をまとめる）。値は住所ブロック
// （parts/Form/Address.vue の dl:not(:first-child) { margin-top: 20px }）に合わせている。
// .row 本体は副管理者 inner box など他用途でも使うため変更せず、新規クラスのみで表現する。
.row_group_head {
  padding: 24px 0 0;
  border-top: 1px solid var(--gray-main);
}
.row_grouped {
  padding: 20px 0 0;
}
.row_group_last {
  padding: 20px 0 24px;
}
.group_heading {
  font-weight: bold;
  margin-bottom: 12px;
}
// 見出しの選択に従属する子行の字下げ。契約プラン配下の「パターン種別」（.contract）と同値
.row_indent {
  padding-left: 1em;
}
.label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  &_wrap {
    display: flex;
    align-items: baseline;
  }
}
// グループの子行ラベル。住所ブロックの子ラベル（font-size: 14px）と揃える
.sub_label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  font-size: 14px;
}
.text, .select {
  &:disabled {
    color: black;
    background-color: transparent;
    &:-webkit-autofill {
      box-shadow: 0 0 0 100px white inset;
    }
  }
}
.required {
  font-size: 12px;
  color: red;
}
.assistant {
  font-size: 12px;
}
.same_as_admin {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.textarea {
  width: 100%;
  resize: vertical;
  min-height: 152.5px;
  border: none;
  outline: none;
  background-color: var(--gray-sub);
  border-radius: 10px;
  padding: 20px;
}
.space {
  padding-top: 6px;
}
.text {
  width: 100%;
  padding: 13px;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  $background: var(--gray-sub);
  &:-webkit-autofill {
    box-shadow: 0 0 0 100px $background inset;
  }
  &_number {
    width: 20%;
    padding: 13px;
    border-radius: 8px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    $background: var(--gray-sub);
    text-align: right;
  }
}
.radio {
  padding-top: 8px;
  display: flex;

  li {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
.select {
  padding: 13px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  border-radius: 8px;
  appearance: none;

  &_wrap {
    display: flex;

    li {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
.tel {
  width: 70px;
  padding: 13px;
}
.number {
  display: flex;
  align-items: baseline;
  ::placeholder {
    text-align: left;
  }
}
.contract {
  padding-left: 1em;
  &_list {
    padding-top: 20px;
  }
}
// 契約名/契約年月日（ブロックB）用。契約プラン radio 配下のネストを外れたため字下げしない
// （オンライン・バーチャル利用可能回数など通常行とインデントを揃える）
.contract_flat {
  padding-left: 0;
  // 先頭項目は親 .row の padding(24px) と .contract_list の padding-top(20px) が重なって
  // 他の行より上余白が大きくなるため、先頭のみ打ち消して通常行と揃える
  > li:first-child {
    padding-top: 0;
  }
}
.text_default_count {
  padding-left: .5em;
}
.helper_text {
  font-size: .85em;
  color: var(--gray-text, #666);
  margin-bottom: 8px;
}
.sub_admin_block {
  margin-bottom: 8px;
}
</style>
